import { useOrderCalculateContext } from '../../../../../contexts/OrderCalculate.context';
import { useOrderConditionContext } from '../../../../../contexts/OrderCondition.context';
import {
  hasIncomeMovement,
  sumSectionsIncomeStatus,
  sumSectionsTotalValue,
} from '../orderSummaryTotals.utils';

interface UseOrderSummaryIncomeStatusParams {
  isReadOnlyView: boolean;
}

const FULL_PERCENT = 100;

const useOrderSummaryIncomeStatus = ({ isReadOnlyView }: UseOrderSummaryIncomeStatusParams) => {
  const { summaryTotals } = useOrderCalculateContext();
  const { selectedCondition } = useOrderConditionContext();

  const sections = summaryTotals?.headers?.sections ?? [];
  const incomeStatus = sumSectionsIncomeStatus(sections);
  const totalValue = sumSectionsTotalValue(sections);

  if (!isReadOnlyView || selectedCondition || !hasIncomeMovement(incomeStatus)) {
    return { incomeStatus: undefined, totalValue: 0, settledPercent: 0 };
  }

  return {
    incomeStatus,
    totalValue,
    settledPercent: totalValue ? (incomeStatus.settledValue / totalValue) * FULL_PERCENT : 0,
  };
};

export default useOrderSummaryIncomeStatus;
